import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id F75C0670-7074-4756-BF30-7840D1C47E09
 * name arrow-expand
 * version: 1.6.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-expand.svg
 * tags
 * - Arrow 
 */
export const ArrowExpandIcon = createSvgIcon(<><path d="M10,21V19H6.41L10.91,14.5L9.5,13.09L5,17.59V14H3V21H10M14.5,10.91L19,6.41V10H21V3H14V5H17.59L13.09,9.5L14.5,10.91Z" /></>, 'ArrowExpandIcon');
export default ArrowExpandIcon